import { render, staticRenderFns } from "./SysCheckRuleModal.vue?vue&type=template&id=49fc55a8&scoped=true"
import script from "./SysCheckRuleModal.vue?vue&type=script&lang=js"
export * from "./SysCheckRuleModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49fc55a8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49fc55a8')) {
      api.createRecord('49fc55a8', component.options)
    } else {
      api.reload('49fc55a8', component.options)
    }
    module.hot.accept("./SysCheckRuleModal.vue?vue&type=template&id=49fc55a8&scoped=true", function () {
      api.rerender('49fc55a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/modules/SysCheckRuleModal.vue"
export default component.exports